import { Config } from "../../../api/config";
export var vehicleHistoryKeys = {
    InstallBaseListKey: 'installBaseListKeyforVH',
    CustomerDetailsKey: 'customerDetailsKeyForVH',
    SeviceHistoryKey: 'serviceHistoryForVH'
};
export var InstallBaseListURL = "".concat(Config.baseURL, "Installbase/ChannelInstallbaseData");
export var customerDetailsGet = function (id) {
    return "".concat(Config.baseURL, "Customer/").concat(id, "/Get");
};
export var serviceHistoryUrl = "".concat(Config.baseURL, "Installbase/ServiceHistories");
